import React, { useEffect, useState } from 'react';
import {
    DivFlexCenter,
    Container,
    ImageHeader,
    DivTextAlignCenter,
    BackButton,
    BackDiv,
    DivQRCode,
    TextLabel,
    SubmitButton,
    IconRight,
    CopyPaste,
    CopyPasteDiv,
    ImageTimeout
  } from '../../styles/styles';
import logo from '../../assets/seclogoanimado.gif';
import errorGif from '../../assets/gif erro.gif'
import { useAlert } from 'react-alert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PoweredBy from '../../assets/powered by@2x.png';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';

const TimeoutPix: React.FC = () => {
    const alert = useAlert();

    const codigoTicket = localStorage.getItem('codigoTicket');
    const idToken = localStorage.getItem('idToken');
    const idEstacionamento = localStorage.getItem('idEstacionamento');

    const goToTicketPage = () => window.location.href = `TK#${idToken}#${idEstacionamento}#${codigoTicket}##`;
    
    return (
        <>
        <BackDiv className="mt-2">
            <BackButton type="button" onClick={goToTicketPage} className="btn btn-icon-only">
                <span style={{ color: '#fff' }}>
                <FontAwesomeIcon size="2x" icon={faChevronLeft as any} />
                </span>
            </BackButton>
        </BackDiv>

        <DivFlexCenter>
            <Container className="mt-2 mb-2">
                <DivTextAlignCenter>
                    <ImageHeader src={logo} style={{ width: '150px', height: '150px' }} alt="Logo" />
                    <hr />

                    <TextLabel>QR Code expirado!</TextLabel>
                    <br/>

                    <ImageTimeout src={errorGif} alt=""></ImageTimeout>
                    <br/>
                    <br/>
                    <SubmitButton id='btnVoltarTelaTicket' style={{width: '100%', margin: '0 auto 0 auto'}} onClick={goToTicketPage}>
                        VOLTAR A TELA DO TICKET
                    </SubmitButton>

                    <hr />
                    <img src={PoweredBy} alt="Powered By" />
                </DivTextAlignCenter>
            </Container>
        </DivFlexCenter>
        </>
    );
};

export default TimeoutPix;